import { render } from "./Navbar.vue?vue&type=template&id=c5774170"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=c5774170&lang=scss"
script.render = render

export default script